import React from 'react'

export default t => [
	{
		Header: <span className='sort-icons'>{t('common.fields.code')}</span>,
		accessor: 'code',
		width: 90
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]
